export const CATEGORY_TYPE_PUBLIC = 'public';
export const CATEGORY_TYPE_MEMBERS_ONLY = 'membersOnly';
export const CATEGORY_TYPE_PRIVATE = 'private';
